import React, { useCallback, useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useDispatch, useStore } from 'react-redux'

import { ReactComponent as SvgDashboard } from '../../assets/svg/dashboard-icon.svg'
import { ReactComponent as SvgVender } from '../../assets/svg/vendor-list-icon.svg'
import { ReactComponent as SvgList } from '../../assets/svg/menu-list.svg'
import { ReactComponent as SvgSupplier } from '../../assets/svg/suppliers-icon.svg'
import { ReactComponent as SvgSchedule } from '../../assets/svg/schedule-icon.svg'
import { ReactComponent as SvgReports } from '../../assets/svg/reports-icon.svg'
import { ReactComponent as SvgSettings } from '../../assets/svg/settings-icon.svg'
import { ReactComponent as SvgQualityAssurance } from '../../assets/svg/quality-assurance-icon.svg'
import { ReactComponent as SvgLogo } from '../../assets/svg/logo.svg'
import { ReactComponent as CollapseSvg } from '../../assets/svg/menu-collapse.svg'
import { ReactComponent as ExpandSvg } from '../../assets/svg/menu-expand.svg'
import { expandSideMenu, collapseSideMenu } from '../../redux/actions/sideMenu'
import MenuButtonImg from '../../assets/img/menu-button.png'
import { ReactComponent as DropdownArrow } from '../../assets/svg/dropdown-arrow.svg'
import { ReactComponent as DropdownUpArrow } from '../../assets/svg/dropdown-arrow-up.svg'
import { checkIsAdminOrModerator } from '../../services/helper'

const SideMenuComponent = () => {
  const history = useHistory()
  const store = useStore().getState()
  const location = useLocation()
  const dispatch = useDispatch()
  const { user, auth } = store
  const { domainUsers } = user

  const currentUserRole = domainUsers.filter(u => u?.user?.id === auth?.user?.id)[0]

  const {
    sideMenu: { isSideMenuExpanded },
    domain: {
      currentDomain,
    }
  } = store

  const isAdminOrModerator = checkIsAdminOrModerator(currentDomain)
  const menuList = [
    { key: 'dashboard', to: 'dashboard', name: 'Dashboard', icon: SvgDashboard, iconActive: SvgDashboard },
    { key: 'upload', to: 'upload', name: 'Add Supplier List', icon: SvgVender, iconActive: SvgVender },
    { key: 'lists', to: 'lists', name: 'My Lists', icon: SvgList, iconActive: SvgList },
    { key: 'suppliers/', to: 'suppliers', name: 'Suppliers', icon: SvgSupplier, iconActive: SvgSupplier },
    { key: 'task', to: 'tasks/emails', name: 'Task', icon: SvgSupplier, iconActive: SvgSupplier },
    // { key: 'schedule', to: 'schedule', name: 'Schedule', icon: SvgSchedule, iconActive: SvgSchedule },
    { key: 'reports', to: 'reports', name: 'Reports', icon: SvgReports, iconActive: SvgReports },
    // { key: 'settings', to: 'settings', name: 'Settings', icon: SvgSettings, iconActive: SvgSettings },
    { key: 'qa/', to: 'qa/', name: 'Qualitv Assurance', icon: SvgQualityAssurance, iconActive: SvgDashboard, submenu:[{key: 'qa/', to: 'qa/', name: 'Supplier Qa', icon: SvgQualityAssurance, iconActive: SvgDashboard}, {key: 'settings', to: 'settings', name: 'Settings', icon: SvgSettings, iconActive: SvgSettings}] },
  ]

  // if (currentDomain?.roleId === 3 && currentDomain?.roleName === 'admin') {
  //   menuList.push({ key: 'test', to: 'test', name: 'Test', icon: SvgList, iconActive: SvgList })
  // }

  const expandMenu = () => {
    dispatch(expandSideMenu())
  }
  const collpaseMenu = useCallback(() => {
    dispatch(collapseSideMenu())
  }, [dispatch])

  const onNavigate = (path) => {
    history.push(`/${path}`)
  }

  useEffect(() => {
    function updateCollapse() {
      if (window.innerWidth <= 767) {
        collpaseMenu()
      } else {
        expandMenu()
      }
    }
    window.addEventListener('resize', updateCollapse)
    updateCollapse()
    return () => window.removeEventListener('resize', updateCollapse)
  }, [collpaseMenu])

  const [isDropdownClicked, setDropdownClick] = useState(false)

  const handledropdownarrowclick = () => {
    setDropdownClick(!isDropdownClicked)
  }

  const renderItem = (item) => {
    if (item.key === "qa/guid") {
      if (currentUserRole?.roleId !== 1) {
        return (
          <div
            key={item.key}
            className={`ms-2 me-2 ${location.pathname.includes(item.to) ? "menu-row active" : "menu-row"}`}
            onClick={() => onNavigate(item.to)}
          >
            <div className={`item-left d-flex align-items-center pt-3 pb-3 ${isSideMenuExpanded ? 'justify-content-start' : 'justify-content-center mb-4'}`}>
              <item.icon onClick={() => onNavigate(item.to)} />
              <span className='menu-item'>{item.name}</span>
            </div>
          </div>
        )
      } else {
        return (
          <>
          </>
        )
      }
    } else if (item.key === "user-manage") {
      if (currentUserRole?.roleId === 3) {
        return (
          <div
            key={item.key}
            className={`ms-2 me-2 ${location.pathname.includes(item.to) ? "menu-row active" : "menu-row"}`}
            onClick={() => onNavigate(item.to)}
          >
            <div className={`item-left d-flex align-items-center pt-3 pb-3 ${isSideMenuExpanded ? 'justify-content-start' : 'justify-content-center mb-4'}`}>
              <item.icon onClick={() => onNavigate(item.to)} />
            </div>
            <span>{item.name}</span>
          </div>
        )
      } else {
        return (
          <>
          </>
        )
      }
    } else if (item.key === "domain") {
      return (
        <div
          key={item.key}
          className={`ms-2 me-2 ${location.pathname.includes(item.to) ? "menu-row active" : "menu-row"}`}
          onClick={() => onNavigate(item.to)}
        >
          <div className={`item-left d-flex align-items-center pt-3 pb-3 ${isSideMenuExpanded ? 'justify-content-start' : 'justify-content-center mb-4'}`}>
            <item.icon onClick={() => onNavigate(item.to)} />
          </div>
          <span>{item.name}</span>
        </div>
      )
    } else {
      return (
        <div
          key={item.key}
          className={`ms-2 me-2 ${location.pathname.includes(item.to) && item.to !=="qa/" ? "menu-row active" : "menu-row"}`}
        >
          <div className={`item-left d-flex align-items-center pt-3 pb-3 ${isSideMenuExpanded ? 'justify-content-start' : `justify-content-center ${item.submenu ? 'mb-3' : 'mb-4'} `}`} onClick={item.submenu ? handledropdownarrowclick : () => { }}>
            <item.icon onClick={() => item.to !== 'settings' && onNavigate(item.to)} />
            <span className="menu-item w-100" onClick={() => onNavigate(item.to)}>{item.name}</span>
            {/* {item.submenu && (
              isDropdownClicked ?
                <DropdownUpArrow className={`menu-dropdown-arrow ${isSideMenuExpanded ? 'ms-auto' : 'ms-2'}`} />
                :
                <DropdownArrow className={`menu-dropdown-arrow ${isSideMenuExpanded ? 'ms-auto' : 'ms-2'}`} />
            )} */}
          </div>
          {item.submenu ? (
              <div className={`${isDropdownClicked ? "submenu-container active" : "submenu-container"} ${isSideMenuExpanded ? 'ms-5 ps-3' : ''}`}>
                <div className={`submenu-vertical-line justify-content-center position-relative ${!isSideMenuExpanded ? 'd-none' : 'd-flex'}`}>
                 
                </div>
                <div className={`submenu-items-container`}>
                  {item.submenu.map((submenu, index) => {
                    if ((submenu.key === "partner-manage" || submenu.key === "caller-settings") && !isAdminOrModerator) {
                      return
                    }
                    if (submenu.key === "user-manage" && currentDomain?.roleId !== 3 && currentDomain?.roleName !== 'admin') {
                      return
                    }
                    return <div
                      key={submenu.key}
                      className={`item-left ms-2 me-2 ${location.pathname.includes(submenu.to) ? "menu-row active" : "menu-row"}`}
                    >
                      <span className="menu-item w-100 pt-3 pb-3" onClick={() => onNavigate(submenu.to)}>
                        {submenu.name}
                      </span>
                    </div>
                  })}
                </div>
              </div>
          ) : (
            <></>
          )}
        </div>
      )
    }
  }

  return (
    <div className={`side-menu-component ${isSideMenuExpanded ? 'expanded' : ''}`}>
      <div className="logo-row justify-content-center">
        {isSideMenuExpanded && <SvgLogo />}
        <img role="button" src={MenuButtonImg} onClick={() => { isSideMenuExpanded ? collpaseMenu() : expandMenu() }} />
      </div>
      {
        menuList.map(renderItem)
      }
      <div className="row-footer">
        {
          isSideMenuExpanded
            ? <CollapseSvg title="Collapse" onClick={() => { collpaseMenu() }} />
            : <ExpandSvg title="Expand" onClick={() => { expandMenu() }} />
        }
      </div>
    </div>
  )
}

export default SideMenuComponent
